<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 9 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <!-- <path
            v-if="weight === 'THIN'"
            d="M11.8075 14.8077L6.99976 10H16.6153L11.8075 14.8077Z"
            fill="currentColor"
        /> -->
        <path 
            v-if="weight === 'THIN'"
            d="M5.59266 4.75623C5.06113 5.41043 4.79536 5.73753 4.47539 5.85629C4.19478 5.96044 3.88611 5.96044 3.6055 5.85629C3.28552 5.73753 3.01976 5.41043 2.48822 4.75623L1.2735 3.26118C0.426385 2.21858 0.00282949 1.69728 2.55223e-05 1.25798C-0.00241266 0.875981 0.169956 0.513838 0.467966 0.274846C0.810684 0 1.48236 0 2.82572 0H5.25516C6.59852 0 7.2702 0 7.61292 0.274846C7.91093 0.513838 8.0833 0.875981 8.08086 1.25798C8.07805 1.69728 7.6545 2.21858 6.80739 3.26119L5.59266 4.75623Z" 
            fill="currentColor"
        />
        <!-- REGULAR -->
        <!-- <path
            v-else-if="weight === 'REGULAR'"
            d="M12.4037 14.4037L7 9H17.8075L12.4037 14.4037Z"
            fill="currentColor"
        /> -->
        <path 
            v-if="weight === 'REGULAR'"
            d="M5.59266 4.75623C5.06113 5.41043 4.79536 5.73753 4.47539 5.85629C4.19478 5.96044 3.88611 5.96044 3.6055 5.85629C3.28552 5.73753 3.01976 5.41043 2.48822 4.75623L1.2735 3.26118C0.426385 2.21858 0.00282949 1.69728 2.55223e-05 1.25798C-0.00241266 0.875981 0.169956 0.513838 0.467966 0.274846C0.810684 0 1.48236 0 2.82572 0H5.25516C6.59852 0 7.2702 0 7.61292 0.274846C7.91093 0.513838 8.0833 0.875981 8.08086 1.25798C8.07805 1.69728 7.6545 2.21858 6.80739 3.26119L5.59266 4.75623Z" 
            fill="currentColor"
        />
        <!-- FILL -->
        <!-- <path
            v-else
            d="M12 15L6 9H18L12 15Z"
            fill="currentColor"
        /> -->
        <path 
            v-else
            d="M5.59266 4.75623C5.06113 5.41043 4.79536 5.73753 4.47539 5.85629C4.19478 5.96044 3.88611 5.96044 3.6055 5.85629C3.28552 5.73753 3.01976 5.41043 2.48822 4.75623L1.2735 3.26118C0.426385 2.21858 0.00282949 1.69728 2.55223e-05 1.25798C-0.00241266 0.875981 0.169956 0.513838 0.467966 0.274846C0.810684 0 1.48236 0 2.82572 0H5.25516C6.59852 0 7.2702 0 7.61292 0.274846C7.91093 0.513838 8.0833 0.875981 8.08086 1.25798C8.07805 1.69728 7.6545 2.21858 6.80739 3.26119L5.59266 4.75623Z" 
            fill="currentColor"
        />
    </svg>
</template>

<script>
    export default {
        name: 'arrow-drop-down-icon',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-content-basic-1',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
